import { useCallback, useEffect, useState } from 'react';

const useFullscreenProps = () => {
  const [ready, setReady] = useState(false);
  const [isFullScreen, setFullScreen] = useState(false);

  const exitHandler = useCallback(() => {
    if (
      !document.fullscreenElement &&
      !document.webkitIsFullScreen &&
      !document.mozFullScreen
    ) {
      setFullScreen(false);
    }
  }, []);

  useEffect(() => {
    if (ready) {
      document.addEventListener('fullscreenchange', exitHandler);
      document.addEventListener('webkitfullscreenchange', exitHandler);
      document.addEventListener('mozfullscreenchange', exitHandler);
      document.addEventListener('MSFullscreenChange', exitHandler);
      return () => {
        document.removeEventListener('fullscreenchange', exitHandler);
        document.removeEventListener('webkitfullscreenchange', exitHandler);
        document.removeEventListener('mozfullscreenchange', exitHandler);
        document.removeEventListener('MSFullscreenChange', exitHandler);
      };
    }
    return setReady(true);
  }, [exitHandler, ready]);

  useEffect(() => {
    if (!ready) {
      return;
    }
    const node = document.querySelector(
      '#game-fullscreen-container, #wc-game-container',
    );

    if (isFullScreen && node) {
      if (node.requestFullscreen) {
        node.requestFullscreen();
      } else if (node.mozRequestFullscreen) {
        node.mozRequestFullscreen();
      } else if (node.webkitRequestFullscreen) {
        node.webkitRequestFullscreen();
      } else if (node.msRequestFullscreen) {
        node.msRequestFullscreen();
      }
    } else {
      const canExit =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement;
      if (!canExit) {
        return;
      }
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }, [isFullScreen, ready]);

  return { isFullScreen, setFullScreen };
};

export default useFullscreenProps;
